import React, { useState } from 'react';
import './FAQ.css';
import { ChevronDown } from 'lucide-react';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How is this different from ChatGPT or Claude?',
      answer:
        "ChatGPT gives you text. We give you platform-optimized posts with proper formatting, hooks, and CTAs for each platform's algorithm. Plus, we analyze your writing style to maintain your voice.",
    },
    {
      question: 'Will it sound like me or like AI?',
      answer:
        'Our engine analyzes your writing style from your newsletter and maintains your voice. Every post is also editable before you copy it, so you have full control.',
    },
    {
      question: 'I write niche/fiction content. Will this work?',
      answer:
        "Currently, our tool is optimized for non-fiction newsletters (business, tech, personal development, marketing, etc.). Fiction content has different narrative structures that we don't support yet. We're built for extracting key insights and actionable takeaways - not story arcs.",
    },
    {
      question: 'What platforms do you support?',
      answer:
        'Currently: LinkedIn (posts + carousels), Twitter/X (tweets + threads). Coming soon based on beta feedback: Instagram, Threads, Bluesky, Pinterest.',
    },
    {
      question: 'Do you post for me automatically?',
      answer:
        'Not yet. We give you the posts, you copy-paste and schedule them yourself. Auto-posting integration is on the roadmap based on what beta users need most.',
    },
    {
      question: 'Why only 25 beta users?',
      answer:
        "We want to work closely with early users to shape the product based on real feedback. You'll get lifetime free access and direct input on what features we build next.",
    },
  ];

  return (
    <section className='faq-section' id='faq'>
      <div className='faq-container'>
        <h2 className='faq-title'>Frequently Asked Questions</h2>

        <div className='faq-list'>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <div className='faq-question'>
                <span>{faq.question}</span>
                <ChevronDown
                  size={20}
                  className={`faq-icon ${openIndex === index ? 'rotate' : ''}`}
                />
              </div>
              {openIndex === index && (
                <div className='faq-answer'>{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
